<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <div class="erma-zadosti-toolbar">
    <app-print-button (buttonClicked)="onSubmit()" (cleared)="onClear()" (closed)="onClose()" [blocked]="blocked" [dialogVisible]="dialogVisible"></app-print-button>
    <app-isds-button (buttonClicked)="onSubmit(true)" [block]="isdsBlocked" *ngIf="isdsBtnVisible"></app-isds-button>
  </div>

  <app-messages [key]="MSG_KEY"></app-messages>

  <div class="erma-zadosti-form">
    <div>

      <h1>Žádost o vystavení potvrzení o původu reprodukčního materiálu pro oddíl vzniklý sloučením oddílů</h1>

      <div class="erma-zadosti-head">
        <label for="cislo">Číslo:</label>
        <input type="number" id="cislo" formControlName="cislo" />
        <label for="rok">rok:</label>
        <input type="number" id="rok" formControlName="rok" />
        <label for="pobocka">Pobočka pověřené osoby:</label>
        <app-ciselnik-dropdown inputId="pobocka" formControlName="pobockaPovereneOsoby" [ciselnikData]="pobockaList" [headerStyle]="true"></app-ciselnik-dropdown>
      </div>

      <div formGroupName="dodavatel">

        <div class="p-grid">
          <div class="p-col-12 sekce">1) Označení dodavatele:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-2">u fyzických osob:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-1 p-offset-1"><label for="jmeno">jméno:</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.dodavatel.jmeno}}&nbsp;</span></div>
          <div class="p-col-1"><label for="prijmeni">příjmení:</label></div>
          <div class="p-col-3"><span class="input-like">{{form.value.dodavatel.prijmeni}}&nbsp;</span></div>
          <div class="p-col-2"><label for="dat-naroz">datum narození:</label></div>
          <div class="p-col-2">
            <span class="input-like" *ngIf="!form.value.dodavatel.prijmeni">&nbsp;</span>
            <input type="date" id="dat-naroz" formControlName="datNaroz" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="obch-nazev-fo">obchodní firma nebo název:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.prijmeni ? form.value.dodavatel.obchNaz : ''}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-trvaleho-pobytu">adresa místa trvalého pobytu:</label></div>
          <div class="p-col-8">
            <span class="input-like" *ngIf="!form.value.dodavatel.prijmeni">&nbsp;</span>
            <input type="text" id="adr-trvaleho-pobytu" formControlName="adresaTrvalehoPobytuFo" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-podnikani-fo">adresa místa podnikání, liší-li se od adresy trvalého pobytu:</label></div>
          <div class="p-col-8">
            <span class="input-like" *ngIf="!form.value.dodavatel.Pprijmeni">&nbsp;</span>
            <input type="text" id="adr-podnikani-fo" formControlName="adresaPodnikaniFo" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-2">u právnických osob:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="obch-nazev-po">obchodní firma nebo název:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.prijmeni ? '' : form.value.dodavatel.obchNaz}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-sidla">adresa sídla:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.adresaSidlaPo}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-4"><label for="ico"><span class="sekce">2) Identifikační číslo dodavatele</span>, bylo-li přiděleno:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.dodavatel.ico}}&nbsp;</span></div>
        </div>

      </div>

      <div formGroupName="licence">

        <div class="p-grid">
          <div class="p-col-2"><label for="licence-cislo"><span class="sekce">3) Licence</span> č.j.</label></div>
          <div class="p-col-3"><span class="input-like">{{form.value.licence.cj}}&nbsp;</span></div>
          <div class="p-col-1"><label for="licence-ze-dne">ze dne</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.licence.zeDne | czechDate}}&nbsp;</span></div>
          <div class="p-col-2"><label for="licence-nabyla-pravni-moci">nabyla právní moci</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.licence.nabylaPravniMoci | czechDate}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3"><label for="licence-cislo-jr">Číslo jednotného registru:</label></div>
          <div class="p-col-2"><app-prefixed-input id="licence-cislo-jr" formControlName="cisloJr"></app-prefixed-input></div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-12 sekce">4) Žádost dodavatele se vztahuje na tyto slučované oddíly:</div>
      </div>

      <div class="erma-repeat" formArrayName="slucovaneOddily" *ngFor="let oddil of form.get('slucovaneOddily')['controls']; let i = index;">

        <!-------------- opakující se část "Slučované oddíly" - začátek ------------------>

        <div [formGroupName]="i">

          <div class="p-grid">
            <div class="p-col-3 sekce"><label for="oddil-zadost-cislo-{{i+1}}">{{i+1}}. k potvrzení o původu číslo:</label></div>
            <div class="p-col-2"><input type="text" id="oddil-zadost-cislo-{{i+1}}" formControlName="cisloPop" (change)="beforPopChangedHandler(i)" (ngModelChange)="popChangedHandler($event, i)"/></div>
            <div class="p-col-1"><label for="oddil-zadost-datum">ze dne:</label></div>
            <div class="p-col-2"><span class="input-like">{{oddil.value.zeDne | czechDate}}&nbsp;</span></div>
            <div class="p-col-2"><label for="oddil-zadost-vystavenemu">vystavenému:</label></div>
            <div class="p-col-2"><span class="input-like">{{oddil.value.vystavenemu}}&nbsp;</span></div>
          </div>

          <div class="p-grid">
            <div class="p-col-4"><label for="mnozstvi-materialu">množství semenného materiálu:</label></div>
            <div class="p-col-1">
              <input type="number" id="mnozstvi-materialu" formControlName="mnozstviMaterialuSem" *ngIf="isSemRm || !druhRmHasValue" />
              <span class="input-like" *ngIf="!isSemRm && druhRmHasValue">&nbsp;</span>
            </div>
            <div class="p-col-1">kg</div>
          </div>

          <div class="p-grid">
            <div class="p-col-4"><label for="mnozstvi-materialu">množství ostatního reprodukčního materiálu:</label></div>
            <div class="p-col-3">
              <app-ciselnik-dropdown inputId="mnozstvi-materialu-druh" formControlName="druhRostlin" [ciselnikData]="druhRostlinList"
                                     *ngIf="!isSemRm || !druhRmHasValue" [nullable]="true"></app-ciselnik-dropdown>
              <span class="input-like" *ngIf="isSemRm && druhRmHasValue">&nbsp;</span>
            </div>
            <div class="p-col-1">
              <input type="number" id="mnozstvi-materialu" formControlName="mnozstviMaterialuOst" *ngIf="!isSemRm || !druhRmHasValue" />
              <span class="input-like" *ngIf="isSemRm && druhRmHasValue">&nbsp;</span>
            </div>
            <div class="p-col-1">ks</div>
          </div>

          <div class="p-grid">
            <div class="p-col-4"><label for="cislo-uj">evidenční číslo uznané jednotky:</label></div>
            <div class="p-col-4"><span class="input-like">{{oddil.value.evCisloUj}}&nbsp;</span></div>
            <div class="p-col-4 right">
              <button type="button" (click)="removeOddil(i)">
                <span>Odebrat oddíl</span>
               </button>
            </div>
          </div>

        </div>

        <!-------------- opakující se část "Slučované oddíly" - konec ------------------>

      </div>

      <div class="p-grid">
        <div class="p-col-12 right"><button type="button" (click)="addOddil()"><span>Přidat oddíl</span></button></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="oblastProvenience">5) Oblast provenience:</label></div>
        <div class="p-col-4">
          <span class="input-like">{{form.value.oblastProvenience ? form.value.oblastProvenience.kod + ' - ' + form.value.oblastProvenience.popis : ''}}&nbsp;</span>
        </div>
      </div>

      <div formGroupName="druhDreviny">

        <div class="p-grid">
          <div class="p-col-2 sekce">6) Druh dřeviny:</div>
          <div class="p-col-2"><label for="druhDreviny-cz-nazev">a) český název:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.druhDreviny?.nazevCesky}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-2 p-offset-2"><label for="druhDreviny-vedecky-nazev">b) vědecký název:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.druhDreviny?.nazevVedecky}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-2 p-offset-2"><label for="druhDreviny-oznaceni-klonu">c) označení klonu nebo směsi klonů:</label></div>
          <div class="p-col-8"><input type="text" id="druhDreviny-oznaceni-klonu" formControlName="oznaceniKlonu" /></div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="katergorie-rm">7) Reprodukční materiál kategorie:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.repMaterialKategorie?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="druh-rm">8) Druh reprodukčního materiálu:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.druhRepMaterialu?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="typ-zdroje-rm">9) Typ zdroje reprodukčního materiálu:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.typZdrojeRepMaterialu?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="puvod">10) Původ:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.puvod?.popis}}&nbsp;</span></div>
        <div class="p-col-1"><label for="puvod-rm">z oblasti: </label></div>
        <div class="p-col-3">
          <span class="input-like">{{form.value.puvodRm}}&nbsp;</span>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="vyskove-pasmo">11) Výškové pásmo:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.vyskovePasmo?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="gen-modifikovany">12) Jedná se o geneticky modifikovaný materiál:</label></div>
        <div class="p-col-8"><input type="checkbox" id="gen-modifikovany" formControlName="genModifikovanyMaterial" /></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="ucel-pouziti">13) Účel použití:</label></div>
        <div class="p-col-4">
          <app-ciselnik-dropdown inputId="ucel-pouziti" formControlName="ucelPouziti" [ciselnikData]="ucelPouzitiList" ></app-ciselnik-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4"><label for="rok-zrani"><span class="sekce">14) Rok zrání</span>, jde-li o semenný materiál:</label></div>
        <div class="p-col-4">
          <span class="input-like">{{form.value.rokZrani}}&nbsp;</span>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4"><label for="vek-a-zpusob-pestovani"><span class="sekce">15) Věk a způsob pěstování</span>, jde-li o sadební materiál:</label></div>
        <div class="p-col-4">
          <input type="text" id="vek-a-zpusob-pestovani" formControlName="zpusobPestovani" *ngIf="isSadRm" />
          <span class="input-like" *ngIf="!isSadRm">&nbsp;</span>
        </div>
      </div>

      <div class="p-grid erma-zadosti-foot">
        <div class="p-col-1"><label for="misto">V</label></div>
        <div class="p-col-2"><input type="text" id="misto" formControlName="misto" /></div>
        <div class="p-col-1"><label for="datum">Dne</label></div>
        <div class="p-col-2"><input type="date" id="datum" formControlName="datum" /></div>
      </div>

    </div>
  </div>

</form>
